import React, { Component } from "react";
import * as Icon from "react-feather";
import clsx from "clsx";

import UtilityService from "../../../../services/UtilityService";

import "./checks-list.css";

export class CheckStatus extends Component {
	render() {
		const { hasPassed, label, className } = this.props;
		const statusClasses = clsx("checks-list__status", hasPassed ? "checks-list__status--passed" : "checks-list__status--failed", className);

		return (
			<span className={statusClasses}>
				{hasPassed ? <Icon.Check size={13} /> : <Icon.AlertTriangle size={13} />}
				{label}
			</span>
		);
	}
}

class ChecksList extends Component {
	render() {
		const { checks, leftHeading, rightHeading, passedLabel } = this.props;
		const formatMoney = amount => UtilityService.formatMoney({ value: amount });

		return (
			<div className="checks-list">
				<div className="checks-list__heading">
					<span />
					<span className="tk-section-label">{leftHeading}</span>
					<span />
					<span className="tk-section-label">{rightHeading}</span>
					<span />
				</div>

				{checks.map(check => (
					<div className="checks-list__check" key={check.key}>
						<div className="checks-list__grid">
							<span className="checks-list__name">{check.label}</span>

							<span className="checks-list__side">
								<span className="checks-list__source">
									<span className="checks-list__report">{check.leftSource}</span>
									<span className="checks-list__detail tk-text-muted">{check.leftDetail}</span>
								</span>
								<span className="checks-list__value tk-amount">{formatMoney(check.leftAmount)}</span>
							</span>

							<span className="checks-list__versus" aria-hidden="true">
								vs
							</span>

							<span className="checks-list__side">
								<span className="checks-list__source">
									<span className="checks-list__report">{check.rightSource}</span>
									<span className="checks-list__detail tk-text-muted">{check.rightDetail}</span>
								</span>
								<span className="checks-list__value tk-amount">{formatMoney(check.rightAmount)}</span>
							</span>

							<CheckStatus hasPassed={check.passed} label={check.passed ? passedLabel : `Out by ${formatMoney(check.difference)}`} />
						</div>

						{!check.passed && <div className="tk-note">{check.explanation}</div>}
					</div>
				))}
			</div>
		);
	}
}

export default ChecksList;
